/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuestId } from "../../commons/types/GuestId";
import { GuestConfig } from "./GuestConfig";
export const Guest = core.serialization
    .object({
    id: GuestId,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
})
    .extend(GuestConfig);
